<input #fileInput type="file" name="fileUpload" [multiple]="multiple" style="display: none" />

@if (icon) {
  <div class="icon">
    @if (!files.length) {
      <button
        class="button"
        mat-button
        [disabled]="disabled"
        [color]="color"
        (click)="onClick()">
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    }
    <!-- one spinner regardless of how many files are in flight -->
    @if (files.length) {
      <mat-spinner
        strokeWidth="3"
        diameter="32"
        mode="indeterminate"
        [color]="color"
      ></mat-spinner>
    }
  </div>
}

@if (!icon) {
  @if (!icon) {
    <button
      class="button"
      mat-button
      [disabled]="disabled"
      [color]="color"
      (click)="onClick()"
      >
      <mat-icon>file_upload</mat-icon>
      {{ text }}
    </button>
  }
  <ul>
    @for (file of files; track file) {
      <li>
        <mat-progress-bar [value]="file.progress"></mat-progress-bar>
        <span class="file-label">
          {{ file.data.name }}
        </span>
      </li>
    }
  </ul>
}

